// ** Redux
import { vendor } from "store/vendor";
import { updateStatisticsSelfAuthorized } from "store/modules/global";
import { setGlobalStatistics } from "store/modules/global-common.slice";

// ** Third party
import md5 from "md5";

// #####################################################

export default async function counterHeader({
	headers,
	bNotificationNotUpdate = false,
	bMessageUpdate = false,
	timeout = 3000,
	noTimeout = false,
}) {
	const header = headers ? headers["datezone-counters"] || null : null;

	if (header == null) {
		return "";
	}

	const countersDataHeader = Buffer.from(header, "base64").toString();

	/**
	 * Parsowanie nagłówka z base64
	 */
	const counter = JSON.parse(countersDataHeader);

	const state = vendor.store.getState();
	const usersOnlineFromStore = state.globalCommon.statistics.usersOnline;

	if (usersOnlineFromStore !== counter.online) {
		/**
		 * Zapis do stora liczników strony (Online, Users, Media)
		 * Asyncronicznie aby nie blokować głównego wątku
		 */
		if (noTimeout) {
			vendor.store.dispatch(
				setGlobalStatistics({
					usersOnline: counter?.online,
					usersTotal: counter?.main?.users,
					mediaTotal: counter?.main?.media,
				})
			);
		} else {
			setTimeout(() => {
				vendor.store.dispatch(
					setGlobalStatistics({
						usersOnline: counter?.online,
						usersTotal: counter?.main?.users,
						mediaTotal: counter?.main?.media,
					})
				);
			}, timeout);
		}
	}

	/**
	 * Zapis do stora liczników użytkownika (Wiadomości, Powiadomienia)
	 * Asyncronicznie aby nie blokować głównego wątku
	 */
	if (counter.authorized) {
		const { main, ...rest } = counter;
		const userStatsHash = md5(JSON.stringify(rest));
		const userStatsHashFromStore =
			vendor.store.getState().global.statisticsSelf.userStatsHash;

		if (userStatsHashFromStore !== userStatsHash) {
			if (noTimeout) {
				vendor.store.dispatch(
					updateStatisticsSelfAuthorized({
						mode: false,
						userpanel: counter.userpanel,
						messages: bMessageUpdate ? null : counter.message,
						notifications: bNotificationNotUpdate
							? null
							: counter.notification,
						userStatsHash: userStatsHash,
					})
				);
			}
			setTimeout(() => {
				vendor.store.dispatch(
					updateStatisticsSelfAuthorized({
						mode: false,
						userpanel: counter.userpanel,
						messages: bMessageUpdate ? null : counter.message,
						notifications: bNotificationNotUpdate
							? null
							: counter.notification,
						userStatsHash: userStatsHash,
					})
				);
			}, timeout);
		}
	}

	return header;
}

// #####################################################
